import type { BetSlipItem, BetSelection } from '@mobi/betslip/types'
import { isSelectionAllowedInMulti } from '@mobi/betslip/helpers/state'

let uniqueCounter = 0 // Initialize a counter

/** Used by client wrapper to create bet slip item */
export const createBetSlipItem = (
  {
    bettingType,
    isEachWayAvailable,
    selection,
    selectionDetails,
    shouldAllowPlaceInvestment,
    betSource,
  }: BetSelection,
  presetData: PresetData = {}
): BetSlipItem => {
  const isAllowedInMulti = isSelectionAllowedInMulti(selection)

  const uniqueId = `${Date.now()}-${uniqueCounter++}`

  return {
    id: uniqueId,
    bettingType,
    isEachWayAvailable,
    isEachWay: presetData.isEachWay || false,
    investment: {
      win: { value: presetData.investmentWin || 0 },
      place: { value: presetData.investmentPlace || 0 },
      bonusBet: undefined,
    },
    isSuperPickAvailable: false,
    selection,
    selectionDetails,
    shouldAllowPlaceInvestment,
    errorMessage: '',
    selectedSuperPickOffer: null,
    isInMulti: isAllowedInMulti,
    multiLegBetType: isAllowedInMulti
      ? 'multiLegBetType' in selection
        ? selection.multiLegBetType
        : 'W'
      : undefined,
    multiBetLegError: null,
    specialOffers: [],
    betSource,
  }
}

// ========
// Types
// ========

type PresetData = {
  investmentWin?: number
  investmentPlace?: number
  isEachWay?: boolean
}
